import { render, staticRenderFns } from "./MediaLibrary.vue?vue&type=template&id=082cebbe"
import script from "./MediaLibrary.vue?vue&type=script&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports